import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const KeywordPositionList = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useTranslation();

  const getColorForPosition = (position) => {
    if (position <= 3) return 'green';
    if (position <= 10) return 'yellow';
    return 'red';
  };

  const formatPosition = (position) => {
    if (position > 10) return '>10e';
    return `${position}e`;
  };

  const isUserRow = (item) => item.competitor === 'Vous';
  const hasDetails = (item) => !isUserRow(item) && !!item.url;

  const toggleRow = (index, item) => {
    if (!hasDetails(item)) return;
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  if (!items?.length) return null;

  return (
    <div className="keyword-position-list">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        const expandable = hasDetails(item);

        return (
          <div
            key={`item-${index}`}
            className={`keyword-position-row${isOpen ? ' open' : ''}`}
          >
            <div
              className={`keyword-position-head${
                expandable ? ' clickable' : ''
              }`}
              onClick={() => toggleRow(index, item)}
            >
              <span
                className={`keyword-position-caret${
                  expandable ? '' : ' hidden'
                }`}
              >
                &#9656;
              </span>
              <span className="keyword-position-domain">
                {t(item.competitor)} :
              </span>
              {expandable && (
                <a
                  className="keyword-position-ext"
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={t('Ouvrir la page')}
                  onClick={(e) => e.stopPropagation()}
                >
                  &#8599;
                </a>
              )}
              <span
                className={`keyword-position-swatch ${getColorForPosition(
                  item.position
                )}`}
              />
              <span className="keyword-position-rank">
                {formatPosition(item.position)}
              </span>
            </div>

            {expandable && (
              <div className="keyword-position-details" hidden={!isOpen}>
                <div>
                  <b>{t('URL')} :</b>{' '}
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.url}
                  </a>
                </div>
                <div>
                  <b>{t('Titre')} :</b> {item.title}
                </div>
                <div>
                  <b>{t('Méta description')} :</b> {item.meta_description}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KeywordPositionList;
